/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByInteractionLabelKind =
  (typeof GroupByInteractionLabelKind)[keyof typeof GroupByInteractionLabelKind];

export const GroupByInteractionLabelKind = {
  interaction_label: 'interaction_label',
} as const;
